import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function getArquivos() {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }
    return new Promise((resolve, reject) => {
        axios.get(API_URL + "/restfull/emsweb/arquivos", config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resposta.data.Rows.forEach(element => {
                    element.loading = false;
                    element.tipodownload = 0;
                });
                resolve(resposta.data.Rows)
            }
        })
    })
}

export function uploadArquivo(data, versao) {

    var self = this;
    var config = {
        headers: {
            versao,
            token: localStorage.getItem('token'),
            sid: sessionStorage.getItem('sid'),
            "Content-Type": "multipart/form-data"
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/ftpuploadservice", data, config).then(resposta => {

            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data)
            }
        })
    })
}

export function deletaArquivo(data) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/deletararquivo", data, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data)
            }
        })
    })
}
export function listaArquivosLiberados(data) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listaarquivosliberados", data, config).then(resposta => {

            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data)
            }
        })
    })
}

export function getArquivosDescontinuados(SISCODIGO) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/arquivosdescontinuados", {SISCODIGO}, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else 
                resolve(resposta.data);            
        })
    })
}

export function liberaArquivos(body) {

    var self = this;
    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/liberaarquivos", body, config).then(resposta => {

            resolve(resposta.data)
        })
    })
}

export function toogleArquivoAtivo(body){
    var self = this;
    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/tooglearquivoativo", body, config).then(resposta => {

            resolve(resposta.data)
        })
    })
}